<template>
    <div>
        <div class="flex flex-col items-center justify-center text-lg font-bold text-center md:text-xl text-brand-blue">
            <img class="mb-6" src="/assets/img/logo.png" alt="Unbundled Legal Help" style="width: 150px;">

            <slot name="title">
                Connecting You to Your Lawyer
            </slot>
        </div>

        <template v-if="pacifier">
            <hr class="my-8 border-b">

            <div class="flex items-center justify-between mt-8">
                <div class="flex items-center justify-start flex-1 text-sm">
                    <div class="flex flex-col items-center justify-center w-16">
                        <i class="mb-2 text-3xl fas fa-phone-alt" :class="[ leadIconClass ]"></i>

                        You
                    </div>
                </div>

                <div class="flex justify-center">
                    <i class="text-3xl text-brand-green fas fa-check" v-if="tenantState === 'answered'"></i>

                    <dots v-else></dots>
                </div>

                <div class="flex items-center justify-end flex-1 text-sm">
                    <div class="flex flex-col items-center justify-center w-16">
                        <i class="mb-2 text-3xl fas fa-phone" :class="[ tenantIconClass ]"></i>

                        Lawyer
                    </div>
                </div>
            </div>
        </template>

        <div class="flex items-center justify-center mt-2 text-center">
            <div class="flex-1"></div>

            <div>
                <div class="text-xl font-bold text-brand-green">
                    <slot name="subtitle"></slot>
                </div>

                <!-- <div class="mt-2 font-bold text-md" v-if="hasTwilioNumber">
                    We&rsquo;re calling from {{ twilioNumber }}
                </div> -->
            </div>

            <div class="flex-1 text-right">
                <button class="px-2 py-px text-xs text-white bg-red-300 border-none rounded hover:bg-red-500"
                    type="submit"
                    @click="cancelCall"
                    v-if="leadState === 'ringing' || leadState === 'initiated'">
                    Cancel call
                </button>
            </div>
        </div>

        <slot name="extra"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            leadState: {
                type: String
            },

            pacifier: {
                type: Boolean,
                default: true
            },

            tenantState: {
                type: String
            }
        },

        computed: {
            hasTwilioNumber() {
                return Boolean(process.env.MIX_TWILIO_NUMBER || false);
            },

            leadIconClass() {
                if (this.leadIconColor) {
                    return `text-${this.leadIconColor}-500`;
                }
            },

            leadIconColor() {
                if (this.leadState === 'answered' || this.tenantState) {
                    return 'green';
                }

                if (this.leadState === 'ringing') {
                    return 'blue';
                }
            },

            tenantIconClass() {
                if (this.tenantIconColor) {
                    return `text-${this.tenantIconColor}-500`;
                }
            },

            tenantIconColor() {
                if (this.tenantState === 'answered') {
                    return 'green';
                }

                if (this.tenantState === 'ringing') {
                    return 'blue';
                }
            },

            twilioNumber() {
                if (this.hasTwilioNumber) {
                    return this.formatPhoneNumber(process.env.MIX_TWILIO_NUMBER);
                }
            },
        },

        methods: {
            cancelCall() {
                this.$event.$emit('cancel-call');
            },

            formatPhoneNumber(phone) {
                phone = phone.trim();

                let phoneTest = new RegExp(/^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})/);
                let results = phoneTest.exec(phone);

                if (results !== null && results.length > 5) {
                    return "(" + results[3] + ") " + results[4] + "-" + results[5];
                }

                return phone;
            }
        }
    }
</script>
